import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import c from "classnames"
import qs from "qs"
import ReactDOM from "react-dom"
import LoadJS from "load-js"
import MediaQuery from "react-responsive"
import Slider from "react-slick"

/*IMG*/
import HorizontalScrollbar from "components/horizontal-scrollbar"

/*UI*/
import SliderForInstagram from "components/ui/Elements/SliderForInstagram"
import { NextArrow, PrevArrow } from "components/ui/SliderArrows"

/*HELPERS*/
import { getValue } from "helpers/Objects"
import { IsIsset } from "helpers/ValueTests"

/*CORES*/
import AppCore from 'cores/AppCore'

class SliderCardListItem extends React.PureComponent {
    mousePosition = false

    handleMouseUp = (e) => {
        if (this.mousePosition !== false) {
            const currentMousePosition = {
                x: e.screenX,
                y: e.screenY,
            }

            if (
                currentMousePosition.x == this.mousePosition.x &&
                currentMousePosition.y == this.mousePosition.y
            ) {
                this.props.onOpen(this.props.id)
            }

            this.mousePosition = false
        }
    }

    handleMouseDown = (e) => {
        this.mousePosition = {
            x: e.screenX,
            y: e.screenY,
        }
    }

    render() {
        const { cmp: Cmp, item, isLibLoaded } = this.props

        return (
            <>
                <Cmp
                    onMouseUp={this.handleMouseUp}
                    onMouseDown={this.handleMouseDown}
                    data={item}
                    isLibLoaded={isLibLoaded}
                />
            </>
        )
    }
}

class SliderCardList extends React.PureComponent {
    SETTINGS = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 350,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        touchMove: true,
        centerMode: false,
        swipeToSlide: true,
        infinite: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    }

    render() {
        const { list = [], isLibLoaded, cmpItem } = this.props

        return (
            <Slider
                {...this.SETTINGS}
                ref={this.props.onRef}
                beforeChange={this.props.onBeforeChange}
            >
                {list.map((item, index) => (
                    <SliderForInstagram.Item key={index}>
                        <SliderCardListItem
                            id={index}
                            item={item}
                            cmp={cmpItem}
                            isLibLoaded={isLibLoaded}
                        />
                    </SliderForInstagram.Item>
                ))}
            </Slider>
        )
    }
}

const InstagramItem = (props = {}) => {
    const { data: alias = "", isLibLoaded, onMouseUp, onMouseDown } = props

    const appId = "739255096912646"
    const clientToken = "867b23467d226837f7c92e59349304a4"

    const [data, setData] = useState(null)

    useEffect(() => {
        fetch(
            `https://graph.facebook.com/v8.0/instagram_oembed?${qs.stringify(
                { url: alias },
                { arrayFormat: "brackets" }
            )}`,
            {
                method: "GET",
                headers: {
                    authorization: `Bearer ${appId}|${clientToken}`,
                },
            }
        )
            .then((response) => {
                response.json().then((resp) => {
                    setData(resp)
                })
            })
            .catch((err) => {
                console.error("[InstagramItem][Error]", err)
            })
    }, [alias])

    useLayoutEffect(() => {
        if (isLibLoaded && IsIsset(data)) {
            window.instgrm.Embeds.process()
        }
    }, [isLibLoaded, data])

    return (
        <div
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            dangerouslySetInnerHTML={{ __html: data ? data.html : "" }}
        />
    )
}

const InstagramSlider = (props = {}) => {
    const { posts = [] } = props
    const [isLibLoaded, setIsLibLoaded] = useState(false)

    const [scrollAreaWidth, setScrollAreaWidth] = useState(0)
    const [scrollWrapperWidth, setScrollWrapperWidth] = useState(0)
    const [scrolling, setScrolling] = useState(0)
    const [dragging, setDragging] = useState(false)

    const refSlider = useRef(null)
    const refScroll = useRef(null)

    const onRefSlider = useCallback((node) => {
        refSlider.current = node
    }, [])

    const onRefScroll = useCallback((node) => {
        refScroll.current = node
    }, [])

    const updateScrollPosition = useCallback(
        (old_index, new_index) => {
            if (!dragging) {
                const precent = (new_index / posts.length) * 100

                setScrolling(precent)
            }
        },
        [dragging, posts]
    )

    const updateSizes = useCallback(() => {
        if (refSlider.current) {
            const scrollDom = ReactDOM.findDOMNode(refSlider.current)

            setScrollAreaWidth(scrollWrapperWidth * posts.length)
            setScrollWrapperWidth(scrollDom.clientWidth)
        }
    }, [posts])

    const normalizeHorizontal = useCallback(
        (nextPos) => {
            const rightEnd = scrollAreaWidth - scrollWrapperWidth

            const trim = (max, min, val) => {
                const tmax = val > max ? max : val
                const tmin = tmax < min ? min : tmax
                return tmin
            }
            const next = trim(rightEnd, 0, nextPos)

            setScrolling((next / scrollAreaWidth) * 100)
        },
        [scrollAreaWidth, scrollWrapperWidth]
    )

    const eventScrollbarDragging = useCallback(() => {
        setDragging(true)
    }, [])

    const eventScrollbarStopDrag = useCallback(() => {
        setDragging(false)
    }, [])

    const eventChangePosition = useCallback(
        (movement) => {
            const next = movement / 100

            normalizeHorizontal(next * scrollAreaWidth)
        },
        [scrollAreaWidth, normalizeHorizontal]
    )

    useEffect(() => {
        updateSizes()

        const tId = setInterval(() => updateSizes, 100)

        return () => {
            clearInterval(tId)
        }
    }, [updateSizes])

    useEffect(() => {
        if (refSlider.current) {
            const coificient = scrolling / 100
            const absIndex = posts.length * coificient
            const index = Math.floor(absIndex)

            refSlider.current.slickGoTo(index)
        }
    }, [scrolling, posts])

    useEffect(() => {
        const libExist = getValue(window, "instgrm.Embeds", null)

        if (libExist === null) {
            LoadJS([
                {
                    async: true,
                    url: "https://platform.instagram.com/ru_RU/embeds.js",
                },
            ])
                .then(() => {
                    console.log("[InstagramItem][Lib][Success]")

                    setIsLibLoaded(true)
                })
                .catch((err) => {
                    console.error("[InstagramItem][Lib][Fail]", err)
                })
        } else {
            setIsLibLoaded(true)
        }
    }, [])

    return (
        <>
            <MediaQuery query="(min-width: 751px)">
                <SliderForInstagram.Slider
                    className={c(
                        { center: posts.length <= 3 },
                        `count_${posts.length}`
                    )}
                >
                    <SliderCardList
                        list={posts}
                        cmpItem={InstagramItem}
                        isLibLoaded={isLibLoaded}
                        onRef={onRefSlider}
                        onBeforeChange={updateScrollPosition}
                    />

                    {posts.length > 3 && (
                        <div className="scroll-bar" ref={onRefScroll}>
                            <HorizontalScrollbar
                                area={{ width: scrollAreaWidth }}
                                wrapper={{
                                    width: scrollWrapperWidth,
                                }}
                                scrolling={scrolling}
                                draggingFromParent={dragging}
                                onChangePosition={eventChangePosition}
                                onDragging={eventScrollbarDragging}
                                onStopDrag={eventScrollbarStopDrag}
                            />
                        </div>
                    )}
                </SliderForInstagram.Slider>
            </MediaQuery>

            <MediaQuery query="(max-width: 750px)">
                <SliderForInstagram.Grid>
                    {posts.map((post, index) => (
                        <SliderForInstagram.GridItem key={index}>
                            <InstagramItem data={post} isLibLoaded={isLibLoaded} />
                        </SliderForInstagram.GridItem>
                    ))}

                    <SliderForInstagram.Grid.Action>
                        <button className="btn btn-primary">
                            <span>
                                { AppCore.Interfaces.t( "DoctorLanding.Ui.ContInstagram.InstagramSlider.ButtonShowAll" ) }
                            </span>
                        </button>
                    </SliderForInstagram.Grid.Action>
                </SliderForInstagram.Grid>
            </MediaQuery>
        </>
    )
}

export default InstagramSlider
